/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Steps_EyebrowInputs */

const es_cap_steps_eyebrow = /** @type {(inputs: Cap_Steps_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

const gl_cap_steps_eyebrow = /** @type {(inputs: Cap_Steps_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona`)
};

const en_cap_steps_eyebrow = /** @type {(inputs: Cap_Steps_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Cap_Steps_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_steps_eyebrow = /** @type {((inputs?: Cap_Steps_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Steps_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_steps_eyebrow(inputs)
	if (locale === "en") return en_cap_steps_eyebrow(inputs)
	return es_cap_steps_eyebrow(inputs)
});